import { ContentListSortingType } from '@norlys-a-s/norlys-play-kmm';

import { ContentListProviders, UIElementContent, UIElementStyle } from '@smart-tv/typings/content';

import { toProviderIdentifier, toUIElementContent } from './helpers';
import { kmm } from './kmm';

export async function getContentSpecialList(
  universeId: number,
  providers: ContentListProviders,
  specialGenreId: number,
  style: UIElementStyle,
  itemLimit: number,
  start = 0
): Promise<UIElementContent> {
  const result = await kmm(
    (repo) =>
      repo.getContentSpecialList(
        start,
        itemLimit,
        universeId,
        ContentListSortingType.NEWEST,
        toProviderIdentifier(providers),
        specialGenreId
      ),
    false
  );

  return toUIElementContent(result, style);
}

export default getContentSpecialList;
